(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["taildash-purchase-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('taildash-purchase-details')) {
    customElements.define('taildash-purchase-details', class TaildashPurchaseDetails extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.slides = Array.from(this.querySelectorAll('[data-td-review]'));
        this.dots = Array.from(this.querySelectorAll('[data-td-review-index]'));
        this.currentReview = 0;
        this.updateDates();
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) this.updateDates();
        }, { signal: this.events.signal });

        if (this.slides.length < 2) return;
        this.showReview(0, false);
        this.querySelector('[data-td-review-controls]').hidden = false;
        this.addEventListener('click', (event) => {
          const control = event.target.closest('[data-td-review-step], [data-td-review-index]');
          if (!control || !this.contains(control)) return;
          const next = control.hasAttribute('data-td-review-index')
            ? Number(control.dataset.tdReviewIndex)
            : this.currentReview + Number(control.dataset.tdReviewStep);
          this.showReview(next, true);
        }, { signal: this.events.signal });
        this.addEventListener('keydown', (event) => {
          if (!event.target.closest('[data-td-review-controls]')) return;
          let next;
          if (event.key === 'ArrowRight') next = this.currentReview + 1;
          if (event.key === 'ArrowLeft') next = this.currentReview - 1;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.slides.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.showReview(next, true);
          this.dots[this.currentReview].focus();
        }, { signal: this.events.signal });
      }

      disconnectedCallback() {
        this.events?.abort();
        this.events = null;
      }

      businessDate(start, days) {
        const date = new Date(start);
        date.setHours(12, 0, 0, 0);
        let remaining = days;
        while (remaining > 0) {
          date.setDate(date.getDate() + 1);
          if (date.getDay() !== 0 && date.getDay() !== 6) remaining -= 1;
        }
        return date;
      }

      updateDates() {
        const ordered = this.querySelector('[data-td-date="ordered"]');
        if (!ordered) return;
        const days = (value, fallback) => {
          const number = Number(value);
          return Number.isFinite(number) ? Math.max(1, Math.min(60, Math.floor(number))) : fallback;
        };
        const processingMin = days(this.dataset.processingMin, 2);
        const processingMax = Math.max(processingMin, days(this.dataset.processingMax, 5));
        const shippingMin = days(this.dataset.shippingMin, 7);
        const shippingMax = Math.max(shippingMin, days(this.dataset.shippingMax, 14));
        const today = new Date();
        const formatter = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
        const range = (minimum, maximum) => {
          const start = this.businessDate(today, minimum);
          const end = this.businessDate(today, maximum);
          return minimum === maximum ? formatter.format(start) : `${formatter.format(start)} – ${formatter.format(end)}`;
        };
        ordered.textContent = formatter.format(today);
        this.querySelector('[data-td-date="ready"]').textContent = range(processingMin, processingMax);
        this.querySelector('[data-td-date="delivered"]').textContent = range(processingMin + shippingMin, processingMax + shippingMax);
      }

      showReview(index, announce) {
        this.currentReview = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, position) => { slide.hidden = position !== this.currentReview; });
        this.dots.forEach((dot, position) => { dot.setAttribute('aria-current', String(position === this.currentReview)); });
        if (!announce) return;
        const status = this.querySelector('[data-td-review-status]');
        if (status) status.textContent = this.dataset.reviewAnnouncement
          .replace('__current__', String(this.currentReview + 1))
          .replace('__total__', String(this.slides.length));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
